import {api} from '../../utils/api'

export default {
    /**
     * get month report
     * @param commit
     * @param user_id
     * @param month
     * @param year
     * @returns {*|Promise|Promise<any>}
     */
    loadMonthReport({commit}, { workspace_id, user_id, month, year, day }) {
        return api.call(commit, 'get', `/api/timelog/report/${workspace_id}/${user_id}/${year}/${month}/${day}`);
    },

    /**
     * get users month report
     * @param commit
     * @param user_id
     * @param month
     * @param year
     * @returns {*|Promise|Promise<any>}
     */
    loadUsersMonthReport({commit}, { month, year, day }) {
        return api.call(commit, 'get', `/api/timelog/users-report/${year}/${month}/${day}`);
    },

    /**
     * get users projects report
     * @param commit
     * @param user_id
     * @param month
     * @param year
     * @returns {*|Promise|Promise<any>}
     */
    loadUsersProjectsReport({commit}, { user_id, month, year, day }) {
        return api.call(commit, 'get', `/api/timelog/users-projects-report/${user_id}/${year}/${month}/${day}`);
    },

    /**
     * Load tasks which was performing during the dates range
     * @param commit
     * @param user_id
     * @param month
     * @param year
     * @returns {*|Promise|Promise<any>}
     */
    loadTasksDuringTheRange({commit}, { from, to, user }) {
        return api.call(commit, 'get', `/api/timelog/tasks-during-dates/${from}/${to}/${user}`);
    },

    /**
     * get users tasks report
     * @param commit
     * @param user_id
     * @param month
     * @param year
     * @returns {*|Promise|Promise<any>}
     */
    loadUsersTasksReport({commit}, {workspace_id, user_id, month, year, day }) {
        return api.call(commit, 'get', `/api/timelog/users-tasks-report/${workspace_id}/${user_id}/${year}/${month}/${day}`);
    },

    /**
     * get all tasks
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    loadLogs({commit}, payload) {
        return api.call(commit, 'get', '/api/timelog/list/'+payload.is_supervisor+'/'+payload.task_id, null, 'SET_LOGS');
    },

    /**
     * Register new log
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    create({ commit }, payload) {

        // Call register
        return api.call(commit, 'post', '/api/timelog', payload, 'SET_LOGS');
    },

    /**
     * Update log
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    update({ commit }, payload) {

        // Call register
        return api.call(commit, 'patch', '/api/timelog/'+payload.id, payload, 'SET_LOGS');
    },

    /**
     * Delete log
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    delete({ commit }, id) {

        // Call register
        return api.call(commit, 'delete', '/api/timelog/'+id, null, 'DELETE_LOGS');
    },

    /**
     * Stop log
     * @param commit
     * @param id
     * @param payload
     * @returns {Promise<any>}
     */
    stop({ commit }, id) {

        // Call register
        return api.call(commit, 'get', '/api/timelog/stop/'+(id?id:""), null, 'SET_LOGS');
    },

}
